import createAsyncAction from "utils/createAsyncAction";
import isTabLockError from "editor/utils/isTabLockError";
import { differentTabLocked } from "editor/actions/status";

export const GET_ITEM_REQUESTED = "GET_ITEM_REQUESTED";
export const GET_ITEM_SUCCEEDED = "GET_ITEM_SUCCEEDED";
export const GET_ITEM_FAILED = "GET_ITEM_FAILED";

export const getItemAsync = id => (dispatch, getState, getClient) => {
  const {
    editor: {
      status: {
        editorType: { name },
        editKey,
      },
    },
  } = getState();

  return createAsyncAction(name, "read", "GET_ITEM")(id, undefined, editKey)(
    dispatch,
    getState,
    getClient
  );
};

export const UPDATE_ITEM_REQUESTED = "UPDATE_ITEM_REQUESTED";
export const UPDATE_ITEM_SUCCEEDED = "UPDATE_ITEM_SUCCEEDED";
export const UPDATE_ITEM_FAILED = "UPDATE_ITEM_FAILED";

export const updateItemAsync = (id, body) => (
  dispatch,
  getState,
  getClient
) => {
  const {
    editor: {
      status: {
        editKey,
        editorType: { name },
      },
    },
  } = getState();

  const errorFunc = error => {
    if (isTabLockError(error)) {
      dispatch(differentTabLocked());
    }
  };

  return createAsyncAction(
    name,
    "update",
    "UPDATE_ITEM",
    args => args,
    errorFunc
  )(id, body, editKey)(dispatch, getState, getClient);
};

export const READ_REVISION_REQUESTED = "READ_REVISION_REQUESTED";
export const READ_REVISION_SUCCEEDED = "READ_REVISION_SUCCEEDED";
export const READ_REVISION_FAILED = "READ_REVISION_FAILED";

export const readRevisionAsync = (contentId, revisionId) => (
  dispatch,
  getState,
  getClient
) => {
  const {
    editor: {
      status: {
        editorType: { name },
      },
    },
  } = getState();

  return createAsyncAction(name, "revisionRead", "READ_REVISION")(
    contentId,
    revisionId
  )(dispatch, getState, getClient);
};

export const GET_CONTENT_REQUESTED = "GET_CONTENT_REQUESTED";
export const GET_CONTENT_SUCCEEDED = "GET_CONTENT_SUCCEEDED";
export const GET_CONTENT_FAILED = "GET_CONTENT_FAILED";

export const getContentAsync = id =>
  createAsyncAction("content", "read", "GET_CONTENT")(id);
